module.exports = __webpack_public_path__ + "img/c3.153a4f1f.png";